var _g, _path, _rect, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBalcony = function SvgBalcony(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#balcony_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 1,
    x: 18,
    y: 13,
    rx: 0.5,
    transform: "rotate(-180 18 13)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 1,
    x: 11,
    y: 19,
    rx: 0.5,
    transform: "rotate(-90 11 19)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 1,
    x: 14,
    y: 19,
    rx: 0.5,
    transform: "rotate(-90 14 19)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 1,
    x: 8,
    y: 19,
    rx: 0.5,
    transform: "rotate(-90 8 19)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 1,
    x: 5,
    y: 19,
    rx: 0.5,
    transform: "rotate(-90 5 19)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M10 .5A7.5 7.5 0 0 1 17.5 8v10a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V8A7.5 7.5 0 0 1 10 .5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 1,
    y: 12,
    fill: "currentColor",
    rx: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 .5a.5.5 0 0 1 .5.5v11.5h-1V1a.5.5 0 0 1 .5-.5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "balcony_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 8a8 8 0 1 1 16 0v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z"
  })))));
};
export default SvgBalcony;